export default __webpack_public_path__ + "static/media/kit_image4.5661ac19.png";